<div class="register-page" role="main" aria-label="Register page">
    <div class="registerWrapper">
        <div class="register-card">
            <div class="login-wrap">
                <h3 [appTranslate]="'REGISTRATION'"></h3>
                <div class="form-group">
                    <label for="register-email" [appTranslate]="'EMAIL'"></label>
                    <input id="register-email" type="email" class="form-control" name="email" [(ngModel)]="registerModel.Email"
                        aria-describedby="register-email-errors">
                    <div id="register-email-errors" class="errors" *ngIf="errors">
                        <span class="error">
                            <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                        </span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="register-name" [appTranslate]="'NAME'"></label>
                        <input id="register-name" type="text" class="form-control" name="name" [(ngModel)]="registerModel.Name"
                            aria-describedby="register-name-errors">
                        <div id="register-name-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'Name'" class="error-feedback"></app-error>
                            </span>
                        </div>

                    </div>
                    <div class="form-group">
                        <label for="register-surname" [appTranslate]="'SURNAME'"></label>
                        <input id="register-surname" type="text" class="form-control" name="surname"
                            [(ngModel)]="registerModel.Surname" aria-describedby="register-surname-errors">
                        <div id="register-surname-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'Surname'" class="error-feedback"></app-error>
                            </span>
                        </div>
                    </div>
                </div>


                <div class="form-row">
                    <div class="form-group">
                        <label for="register-street" [appTranslate]="'STREET'"></label>
                        <input id="register-street" type="text" class="form-control" name="street"
                            [(ngModel)]="registerModel.Street" aria-describedby="register-street-errors">
                        <div id="register-street-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'Street'" class="error-feedback"></app-error>
                            </span>
                        </div>
                    </div>
                    <div class="form-group form-group--narrow">
                        <label for="register-street-number" [appTranslate]="'NUMBER'"></label>
                        <input id="register-street-number" type="text" class="form-control" name="streetNum"
                            [(ngModel)]="registerModel.StreetNumber" aria-describedby="register-street-number-errors">
                        <div id="register-street-number-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'StreetNumber'"
                                    class="error-feedback"></app-error>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="register-phone" [appTranslate]="'PHONE_NUMBER'"></label>
                    <input id="register-phone" type="tel" class="form-control" name="tel"
                        [(ngModel)]="registerModel.PhoneNumber" aria-describedby="register-phone-errors">
                    <div id="register-phone-errors" class="errors" *ngIf="errors">
                        <span class="error">
                            <app-error [errors]="errors" [ErrorKey]="'PhoneNumber'" class="error-feedback"></app-error>
                        </span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="register-password" [appTranslate]="'PASSWORD'"></label>
                        <input id="register-password" type="password" class="form-control" name="password"
                            [(ngModel)]="registerModel.Password" aria-describedby="register-password-errors">
                        <div id="register-password-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'Password'" class="error-feedback"></app-error>
                            </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="register-confirm-password" [appTranslate]="'CONFIRM_PASSWORD'"></label>
                        <input id="register-confirm-password" type="password" class="form-control" name="confirmPass"
                            [(ngModel)]="registerModel.ConfirmPassword" aria-describedby="register-confirm-password-errors">
                        <div id="register-confirm-password-errors" class="errors" *ngIf="errors">
                            <span class="error">
                                <app-error [errors]="errors" [ErrorKey]="'ConfirmPassword'"
                                    class="error-feedback"></app-error>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="loginBtn" *ngIf="!successfulReg">
                    <button type="button" class="btn-primary" (click)="register()"><span
                            [appTranslate]="'REGISTRATION'"></span> </button>
                </div>
                <div class="errors error-messages errorReason" *ngIf="errors">
                   <app-error [errors]="errors" [ErrorKey]="''" class="mainErrorReason"></app-error>
                </div>
                <div *ngIf="successfulReg" class="succesReg">
                    <span [appTranslate]="'SUCCESSFUL_REGISTRATION'"></span>                  
                </div>
                  <button type="button" (click)="redirect()" [appTranslate]="'TO_LOGIN'" class="btn-link" aria-label="Go to login"></button>
            </div>
        </div>
    </div>
</div>